import { render, staticRenderFns } from "./ClientsInvoiceCard.vue?vue&type=template&id=4704ac9f&scoped=true&"
import script from "./ClientsInvoiceCard.vue?vue&type=script&lang=js&"
export * from "./ClientsInvoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientsInvoiceCard.vue?vue&type=style&index=0&id=4704ac9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704ac9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
